import AbstractFilterDefinition from './AbstractFilterDefinition.js'
import Store from 'Services/Store';

export default class StaffsFilterDefinition extends AbstractFilterDefinition
{
    constructor(name, label, secondaryLabel, staffs, me = true) {
        super(name, label);
        this.staffs = staffs;
        this.me = me;
        this.secondaryLabel = secondaryLabel
    }

    get component() {
        return 'checkbox2lvl-filter';
    }

    dataAdapter(data) {
        let staffIds = [...data.subChoices];

        if (data.choices.indexOf('me') != -1) {
            staffIds.push(Store.get('user').id);
        }

        //Array unique
        staffIds = staffIds.filter(function (value, index, self) {
            return self.indexOf(value) === index;
        });

        return staffIds.length > 0 ? staffIds : null;
    }

    get configuration() {
        let staffs = typeof this.staffs == 'function' ? this.staffs() : this.staffs;

        if (staffs.length == 0) {
            return null;
        }

        if (staffs.length == 1 && staffs[0].id == Store.get('user').id) {
            return null;
        }

        let groups = {
            _other: { label:  i18n.__("Autre"), value: 0, options: [] }
        };


        staffs.forEach(function (staff) {
            let formattedStaff = { label: staff.firstname + ' ' + staff.lastname, value: staff.id };
            if (staff.groups) {
                staff.groups.forEach(function (group) {
                    if (!groups.hasOwnProperty(group.id)) {
                        groups[group.id] = { label: group.name, value: group.id, options: [] }
                    }
                    groups[group.id].options.push(formattedStaff)
                })
            } else {
                groups._other.options.push(formattedStaff)
            }
        });


        if (this.me && Store.get('user').id) {
            groups._me = { label: i18n.__("Utilisateur courant"), value: "me", options: [] };
        }

        let configuration =  {
            "choices": {
                "name": "choices",
                "type": "checkbox",
                "options": Object.values(groups)
            },
            "subChoices": {
                "type": "checkbox",
                "name": "subChoices",
                "options": []
            }
        };
        return configuration;
    }

    build() {
        let data = super.build();
        data.label2 = this.secondaryLabel;
        return data;
    }
}